/*
  Contains build information about which server domain to access depending on 
  whether react client is in dev, tesing, or production mode
*/

// Google OAuth client ID is selected by HOSTNAME so a single build can serve
// both clubwealthu.com (original app) and learning.clubwealth.com (new app) at
// the same time during the domain migration. We use the new-domain app on
// learning(dev).clubwealth.com because we don't have console access to the
// original app's Google project. MUST stay in sync with getGoogleCredentials()
// in InfusionsoftIntegration/oauthCredentials.js (which picks GG_REPLIT_* for
// the same hosts). Facebook + Microsoft intentionally stay on the original apps.
const ORIGINAL_GOOGLE_CLIENT_ID =
  '865629118314-1f3ftm3j7bncakfqt6stf9lm72tk7446.apps.googleusercontent.com';
const NEW_DOMAIN_GOOGLE_CLIENT_ID =
  '869045140804-pqhenur288tp06tg6ek3uq7q40fr2k83.apps.googleusercontent.com';
const NEW_FRONTEND_HOSTS = [
  'learning.clubwealth.com',
  'learningdev.clubwealth.com'
];
const googleClientId =
  typeof window !== 'undefined' &&
  NEW_FRONTEND_HOSTS.includes(window.location.hostname)
    ? NEW_DOMAIN_GOOGLE_CLIENT_ID
    : ORIGINAL_GOOGLE_CLIENT_ID;

// Microsoft OAuth client ID is also hostname-selected. learning[dev].clubwealth.com
// uses the company-owned "Clubwealth-API" app (395...) -- we have full access to it,
// and the original "ClubWealth" app (2699bb9c...) is orphaned (owner left the company).
// clubwealthu.com keeps 2699bb9c... until cutover. MUST match getMicrosoftCredentials()
// in InfusionsoftIntegration/oauthCredentials.js.
const ORIGINAL_MICROSOFT_CLIENT_ID = '2699bb9c-64ce-4f45-a2f3-a87b1e520c51';
const NEW_DOMAIN_MICROSOFT_CLIENT_ID = '395a0162-6d13-443a-9b70-079554a04827';
const microsoftClientId =
  typeof window !== 'undefined' &&
  NEW_FRONTEND_HOSTS.includes(window.location.hostname)
    ? NEW_DOMAIN_MICROSOFT_CLIENT_ID
    : ORIGINAL_MICROSOFT_CLIENT_ID;

// Facebook OAuth app is also hostname-selected. learning[dev].clubwealth.com
// uses the company-owned "Club Wealth University SSO" app (2002...). We don't
// have admin on the original "Club Wealth U" app (787...), so clubwealthu.com
// keeps it until cutover. MUST match getFacebookCredentials() in
// InfusionsoftIntegration/oauthCredentials.js (which picks FB_NEW_* for the
// same hosts).
const ORIGINAL_FACEBOOK_CLIENT_ID = '787179298713207';
const NEW_DOMAIN_FACEBOOK_CLIENT_ID = '2002135336782992';
const facebookClientId =
  typeof window !== 'undefined' &&
  NEW_FRONTEND_HOSTS.includes(window.location.hostname)
    ? NEW_DOMAIN_FACEBOOK_CLIENT_ID
    : ORIGINAL_FACEBOOK_CLIENT_ID;

module.exports = {
  googleClientId,
  microsoftClientId,
  facebookClientId,
  baseUrl:
    process.env.NODE_ENV === 'production'
      ? window.location.origin
      : 'http://localhost:3001',
  developmentRedirectUrl: 'https://127.0.0.1',
  productionRedirectUrl: 'https://clubwealthu.com',
  redirectUrl:
    process.env.mode === 'production'
      ? 'https://clubwealthu.com'
      : 'https://127.0.0.1',
  mediaServerBaseUrl:
    process.env.REACT_APP_MEDIA_TEST === 'true'
      ? 'http://localhost:4443'
      : 'https://videoapi.clubwealth.com'
};
